<template class="template-root">
  <div class="root" v-if="rootShow">
    <van-nav-bar
      title="百变工具箱"
    />

    <wechat-voice v-if="active===0"></wechat-voice>

    <wechat-video v-if="active===1"></wechat-video>

    <van-tabbar v-model="active" @change="tabChange">
      <van-tabbar-item icon="home-o">公众号下载音频</van-tabbar-item>
      <van-tabbar-item icon="video-o">公众号下载视频</van-tabbar-item>
    </van-tabbar>

    <div class="bottom">
      <img width="200" src="../assets/logo.png">
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Dialog, NavBar, Toast} from 'vant';
import {Tabbar, TabbarItem} from 'vant';
import WechatVoice from '@/components/module/WechatVoice';
import WechatVideo from '@/components/module/WechatVideo';

Vue.use(Dialog);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(NavBar);

export default {
  name: 'Root',
  components: {
    "wechat-voice": WechatVoice,
    "wechat-video": WechatVideo,
  },
  data() {
    return {
      rootShow: false,
      active: 0,
      isDot: true
    }
  },
  methods: {
    tabChange: function () {
      this.isDot = false
    },
    isWechatOpen: function () {
      // return true;

      var ua = window.navigator.userAgent.toLowerCase();
      // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
      if (ua.indexOf('micromessenger') > -1) {
        return true; // 是微信端
      } else {
        return false;
      }
    },
    pollingWechat: function () {
      this.rootShow = true

      if (this.isWechatOpen()) {
        this.rootShow = true
      } else {
        Dialog.alert({
          message: '请在微信中打开该链接',
          theme: 'round-button',
        }).then(() => {
          this.pollingWechat()
        });
      }
    }
  },
  created() {
    this.pollingWechat()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.template-root {
}

.root {
  padding-left: 15px;
  padding-right: 15px;
  background-color: #F7F8FA;
}


.bottom {
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Root.vue